if (!customElements.get('cart-giftcard')) {
  class CartGiftcard extends HTMLElement {
    constructor() {
      super();

      this.cartDrawer = document.querySelector('cart-drawer');
      this.cartItem = this.closest('[data-line-item-key]');
      this.cartItemQuantityInput = this.cartItem.querySelector(
        'quantity-input input',
      );
      this.cartItems = this.cartItem.closest('cart-drawer-items');
      this.buttonToggle = this.querySelector('[data-button-toggle]');
      this.buttonUpdate = this.querySelector('[data-button-update]');
      this.buttonEdit = this.querySelector('[data-button-edit]');
      this.messageInput = this.querySelector('[data-message-input]');
      this.messageInputCounter = this.querySelector(
        '[data-message-input-counter]',
      );
      this.initialValues = {
        message: this.messageInput.value,
        variantId: this.getSelectedVariantId(),
      };
      this.giftcardItem = this.cartItems.querySelector(
        `[data-line-item-key="${this.dataset.giftcardItemKey}"]`,
      );
      this.isGiftcardItem = this.cartItem === this.giftcardItem;
    }

    connectedCallback() {
      this.buttonToggle?.addEventListener('click', () => {
        if (this.classList.contains('is-filled')) {
          this.removeProduct();

          return;
        }

        this.toggleOpenState(!this.classList.contains('is-open'));
      });

      this.buttonUpdate.addEventListener('click', () => {
        this.toggleProduct();
      });

      this.buttonEdit?.addEventListener('click', () => {
        this.toggleOpenState();
      });

      this.messageInput.addEventListener('input', () => {
        this.messageInputCounter.textContent = this.messageInput.value.length;
      });

      this.addEventListener('change', (e) => {
        e.stopImmediatePropagation();
      });
    }

    disconnectedCallback() {
      const removeProduct =
        this.giftcardItem &&
        +this.cartItemQuantityInput.value <= 0 &&
        !this.isGiftcardItem;

      if (removeProduct) this.removeProduct();
    }

    toggleOpenState(open = true) {
      this.classList.toggle('is-open', open);

      if (open) {
        this.messageInput.focus();
        this.messageInput.setSelectionRange(
          this.messageInput.value.length,
          this.messageInput.value.length,
        );
      }

      if (this.classList.contains('is-filled')) return;

      const buttonLabel = this.buttonToggle?.querySelector('[data-label]');

      if (!buttonLabel) return;

      buttonLabel.textContent = open
        ? this.buttonToggle.dataset.textAdded
        : this.buttonToggle.dataset.textDefault;
    }

    addProduct() {
      const selectedVariant = this.querySelector('[data-variant-id]:checked');
      const formData = {
        items: [
          {
            id: selectedVariant.dataset.variantId,
            quantity: 1,
            properties: {
              message: this.messageInput.value,
              _linked_item_key: this.cartItem.dataset.lineItemKey,
            },
          },
        ],
        sections: this.cartDrawer
          .getSectionsToRender()
          .map((section) => section.section),
        sections_url: window.location.pathname,
      };
      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      };

      this.cartDrawer.classList.add('is-loading');

      return fetch(`${window.Shopify.routes.root}cart/add.js`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }

          this.cartDrawer.renderContents(response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.cartDrawer.classList.remove('is-loading');
        });
    }

    updateProduct() {
      const itemIndex = +this.giftcardItem.dataset.lineItemIndex;
      const messageValue = this.messageInput.value
        ? this.messageInput.value
        : null;
      const properties = {
        message: messageValue,
      };

      if (!this.isGiftcardItem) {
        properties._linked_item_key = this.cartItem.dataset.lineItemKey;
      }

      // Linked add-on giftcards are always qty 1; a standalone card product
      // keeps its own quantity so editing the message doesn't reset it.
      const quantity = this.isGiftcardItem
        ? +this.cartItemQuantityInput.value
        : 1;

      this.cartItems.updateItems(itemIndex, quantity, null, properties);
    }

    removeProduct() {
      return this.cartItems.updateItems(
        +this.giftcardItem.dataset.lineItemIndex,
        0,
      );
    }

    async toggleProduct() {
      try {
        const isOpen = this.classList.contains('is-open');

        if (!isOpen || this.matchesInitialState()) {
          this.toggleOpenState(!isOpen);

          return;
        }

        if (this.giftcardItem) {
          if (
            this.matchesInitialVariant() &&
            (this.messageInput.value || this.isGiftcardItem)
          ) {
            this.updateProduct();

            return;
          }

          await this.removeProduct();
        }

        if (this.messageInput.value) await this.addProduct();
      } catch (error) {
        console.error(error);
      }
    }

    getSelectedVariantId() {
      return (
        this.querySelector('input[data-variant-id]:checked')?.dataset
          .variantId || null
      );
    }

    matchesInitialState() {
      return (
        this.matchesInitialMessage() &&
        (this.matchesInitialVariant() || this.initialValues.message === '')
      );
    }

    matchesInitialMessage() {
      return this.messageInput.value === this.initialValues.message;
    }

    matchesInitialVariant() {
      return this.getSelectedVariantId() === this.initialValues.variantId;
    }
  }

  customElements.define('cart-giftcard', CartGiftcard);
}
